export const TYPE_MODULE = 'module'

export const LABELS = {
  headline: 'Veeva Vault Asset Picker',
  searchPlaceholder: 'Start typing to search...',
  noResults: 'No results.',
  notAvailable: 'Selected item is not available anymore.',
  noResultsOnSearch: 'Please try another search term to find something fitting'
}
